/**
 * ResizeObserver loop-error shim. MUST be the first import of the app so it
 * runs before any library (Highcharts, flowbite) captures window.ResizeObserver.
 *
 * The browser raises "ResizeObserver loop completed with undelivered
 * notifications" / "loop limit exceeded" when observed elements change size
 * again while notifications are being delivered in the same frame — e.g. our
 * tab panels flipping display:none↔block, which reflows every mounted
 * Highcharts container at once. The condition is benign (leftovers are
 * delivered next frame) but surfaces as a window error, which CRA's dev
 * overlay escalates to the red screen.
 *
 * Delivering callbacks on the next animation frame sidesteps the same-frame
 * loop detection entirely, so the error never fires — any browser, dev or
 * prod. Cost: observers see resizes one frame late, which no consumer here
 * depends on (our own useVisibleItems already defers via rAF).
 */
const NativeResizeObserver = window.ResizeObserver;

if (NativeResizeObserver) {
    class DeferredResizeObserver extends NativeResizeObserver {
        constructor(callback) {
            let frame = null;
            let pendingEntries = [];
            super((entries, observer) => {
                pendingEntries = entries;
                if (frame) return; // coalesce bursts into one delivery
                frame = window.requestAnimationFrame(() => {
                    frame = null;
                    callback(pendingEntries, observer);
                });
            });
        }
    }
    window.ResizeObserver = DeferredResizeObserver;
}

export {};
